import createVueComponent from '../createVueComponent';
var SignalZero = createVueComponent('SignalZeroIcon', [['path', {
  d: 'M2 20h.01'
}]]);
export default SignalZero;